import { api } from "..";

import { User } from "@/types/User";

export interface UpdateAllSubdealerPayload {
  highOddsValue: number;
  lowOddsValue: number;
  bulkOddsValue: number;
  removeMatchMinute: number;
  highOddsThreshold: string;
  lowOddsThreshold: string;
  oddsChangeBehavior: string;
  removeMatchAction: string;
  type: "live" | "line";
}

export async function updateAllSubdealer(
  payload: UpdateAllSubdealerPayload
): Promise<User> {
  const res = await api.client.put(
    "/main-dealers/update-all-subdealer",
    payload
  );
  return res.data;
}
